import React, { useCallback, useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { format } from 'date-fns';
import setUiMessage from '../../../Utilities/Tostify';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import RecurrencePopup from '../Appointment/RecurrencePopup';
import Button from '../../Button';
import { useSelector } from 'react-redux';
import { getMaskDate, getMaskTime } from '../../../Utilities/Utilities';


function AddTaskPopup({
  eventData = null,
  handleClose,
  handleReload = () => {},
  recurrCheck = false,
  fromCalFlag = false,
}) {
  const { user } = useSelector((state) => state.auth);
  const { defaultTimeFormat } = useSelector((store) => store.app);
  const [allData, setAllData] = useState(null);
  const [provider, setProvider] = useState(eventData?.user_id || user?.id);
  const [location, setLocation] = useState(eventData?.location_id || 'all');
  const [textDesc, setTextDesc] = useState(eventData?.task_description || '');
  const [isBlocked, setIsBlocked] = useState(
    eventData ? (eventData?.blocked_flag === '0' ? '0' : '2') : '0',
  );

  const [schedule, setSchedule] = useState({
    startDate: (() => {
      const date = eventData?.task_start_time
        ? new Date(eventData?.task_start_time)
        : new Date();
      if (!eventData?.task_start_time) date.setHours(0, 0, 0, 0);
      return date;
    })(),
    startTime: eventData?.task_start_time
      ? new Date(eventData?.task_start_time)
      : null,
    endDate: eventData?.task_end_time
      ? new Date(eventData?.task_end_time)
      : null,
    endTime: eventData?.task_end_time
      ? new Date(eventData?.task_end_time)
      : null,
    startDateOcc: eventData?.task_start_time
      ? new Date(eventData?.task_start_time)
      : new Date(),
    startTimeOcc: eventData?.task_start_time
      ? new Date(eventData?.task_start_time)
      : null,
    endTimeOcc: eventData?.task_end_time
      ? new Date(eventData?.task_end_time)
      : null,
  });

  const [pickers, setPickers] = useState({
    stDate: false,
    stTime: false,
    ndDate: false,
    ndTime: false,
  });

  const togglePicker = (name) => {
    setPickers((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const updateSchedule = (key, value) => {
    setSchedule((prev) => {
      const newSchedule = { ...prev, [key]: value };
      if (isBlocked === '2' && key === 'startDate') {
        newSchedule.endDate = value;
      }
      return newSchedule;
    });
  };

  const [editMode, setEditMode] = useState(
    eventData?.blocked_flag ? false : false,
  );
  const [conFirmDelete, setConFirmDelete] = useState({ status: false, id: 0 });
  const [recurringCheck, setRecurringCheck] = useState(
    recurrCheck ? (recurrCheck === '1' ? true : false) : false,
  );
  const [recurranceFormData, setRecurranceFormData] = useState(false);

  useEffect(() => {
    if (isBlocked === '2') {
      setRecurringCheck(false);
      setSchedule((prev) => ({ ...prev, endDate: prev.startDate }));
    }
  }, [isBlocked]);

  useEffect(() => {
    (async () => {
      const response = await post(
        'api/appointment/appointment/openAddTaskPopup',
        {
          taskId: eventData?.indv_task_id ? eventData?.indv_task_id : 0,
        },
      );
      if (response.status === 200) {
        setAllData(response?.data);
        if (response?.data?.taskInfo?.taskRecurData && isBlocked !== '2') {
          setRecurringCheck(true);
        }
        setSchedule((prev) => ({
          ...prev,
          startTime: response?.data?.taskInfo?.task_start_time
            ? new Date(response?.data?.taskInfo?.task_start_time)
            : null,
          endTime: response?.data?.taskInfo?.task_end_time
            ? new Date(response?.data?.taskInfo?.task_end_time)
            : null,
        }));
      }
    })();
  }, [eventData?.indv_task_id]);

  const handleRecurErrors = (recurranceFormData) => {
    let flag = false;
    if (recurranceFormData.occur_type === '0') {
      if (recurranceFormData?.recur_value === '') {
        setUiMessage('err', 'Select recur every week(s) on');
        flag = true;
      }
      if (
        recurranceFormData?.chckMon === 0 &&
        recurranceFormData?.chckTue === 0 &&
        recurranceFormData?.chckWed === 0 &&
        recurranceFormData?.chckThu === 0 &&
        recurranceFormData?.chckFri === 0 &&
        recurranceFormData?.chckSat === 0 &&
        recurranceFormData?.chckSun === 0
      ) {
        setUiMessage('err', 'Select any week day for processing.');
        flag = true;
      }
      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    if (recurranceFormData.occur_type === '1') {
      if (recurranceFormData?.sub_occur_type === '0') {
        if (recurranceFormData?.monthly_day === '') {
          setUiMessage('err', 'Select days of.');
          flag = true;
        }
        if (recurranceFormData?.recur_value === '') {
          setUiMessage('err', 'Select months(s).');
          flag = true;
        }
      } else {
        if (recurranceFormData?.week_day === '') {
          setUiMessage('err', 'Select value from dropdown');
          flag = true;
        }
        if (recurranceFormData?.monthly_day === '') {
          setUiMessage('err', 'Select day from dropdown');
          flag = true;
        }
      }
      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    if (recurranceFormData.occur_type === '2') {
      if (recurranceFormData?.recur_value === '') {
        setUiMessage('err', 'Select recur every week(s) on.');
        flag = true;
      }

      if (recurranceFormData?.sub_occur_type === '0') {
        if (recurranceFormData?.yearly_day === '') {
          setUiMessage('err', 'Select on field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_month === '') {
          setUiMessage('err', 'Select on field from recurrence.');
          flag = true;
        }
      } else {
        if (recurranceFormData?.week_day === '') {
          setUiMessage('err', 'Select on the field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_day === '') {
          setUiMessage('err', 'Select on the second field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_month === '') {
          setUiMessage('err', 'Select on the last field from recurrence.');
          flag = true;
        }
      }

      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    return flag;
  };

  const handleSaveTask = async () => {
    const selectElement = document.getElementById('providerid');
    const selectedText =
      selectElement.options[selectElement.selectedIndex].text;
    const {
      startDate,
      startTime,
      endDate,
      endTime,
      startDateOcc,
      startTimeOcc,
      endTimeOcc,
    } = schedule;

    if (!recurringCheck) {
      if (!startDate)
        return setUiMessage('war', 'Start date can not be blank.');
      if (!startTime)
        return setUiMessage('war', 'Start time can not be blank.');
      if (!endDate) return setUiMessage('war', 'End date can not be blank.');
      if (!endTime) return setUiMessage('war', 'End time can not be blank.');
      if (
        Date.parse(startDate) > Date.parse(endDate) ||
        Date.parse(startTime) >= Date.parse(endTime)
      ) {
        return setUiMessage(
          'war',
          'Can not select end time less than or equal to start time.',
        );
      }
    } else {
      if (!startDateOcc)
        return setUiMessage('war', 'Start date can not be blank.');
      if (!startTimeOcc)
        return setUiMessage('war', 'Start time can not be blank.');
      if (!endTimeOcc) return setUiMessage('war', 'End time can not be blank.');
      if (Date.parse(startTimeOcc) >= Date.parse(endTimeOcc)) {
        return setUiMessage(
          'war',
          'Can not select end time less than or equal to start time.',
        );
      }
    }

    if (selectedText === '')
      return setUiMessage('war', 'Please select resource.');
    if (recurringCheck && handleRecurErrors(recurranceFormData)) return;

    try {
      const prams = {
        taskId: eventData?.indv_task_id,
        resource_id: provider,
        taskLocation: location,
        taskDescription: textDesc,
        block_flag: isBlocked,
        startDate:
          !recurringCheck && startDate ? format(startDate, 'yyyy-MM-dd') : '',
        startTime:
          !recurringCheck && startTime ? format(startTime, 'hh:mm a') : '',
        endDate:
          !recurringCheck && endDate
            ? isBlocked === '2'
              ? format(startDate, 'yyyy-MM-dd')
              : format(endDate, 'yyyy-MM-dd')
            : '',
        endTime: !recurringCheck && endTime ? format(endTime, 'hh:mm a') : '',
        loginUserId: user?.id,
        appmtOption: recurringCheck ? '1' : '0',
        startDateOcc:
          recurringCheck && startDateOcc
            ? format(startDateOcc, 'yyyy-MM-dd')
            : '',
        startTimeOcc:
          recurringCheck && startTimeOcc ? format(startTimeOcc, 'hh:mm a') : '',
        endTimeOcc:
          recurringCheck && endTimeOcc ? format(endTimeOcc, 'hh:mm a') : '',
      };

      const pramsObj = recurringCheck
        ? { ...prams, ...recurranceFormData }
        : prams;

      const response = await post(
        'api/appointment/Appointment/saveThisTask',
        pramsObj,
      );
      if (response.status === 200 && response.data.successCode === '1') {
        setUiMessage('suc', 'Task save successfully.');
        handleClose();
        handleReload();
      } else if (response.status === 200 && response.data.successCode === '2') {
        setUiMessage(
          'err',
          'The calendar is already open for this appointment slot.',
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleDeleteTask = useCallback((taskId) => {
    setConFirmDelete((prev) => ({ ...prev, status: true, id: taskId }));
  }, []);

  const handleDeleteTempletConfirm = useCallback(
    async (taskId) => {
      const response = await post(
        'api/appointment/appointment/deleteThisTask',
        {
          taskId: taskId,
          recurringId: eventData?.recurring_id,
          placeOfDel: '0',
          delType: recurrCheck || '0',
          loginUserId: user?.id,
        },
      );
      if (response.status === 200 && response.data?.status === '1') {
        setUiMessage('suc', 'Task delete successfully');
        handleClose();
        handleReload();
      } else {
        setUiMessage('err', 'Something went wrong. Unable to delete task.');
      }
    },
    [eventData?.recurring_id, recurrCheck, user?.id, handleClose, handleReload],
  );

  const handleRecurranceFormData = useCallback((data) => {
    setRecurranceFormData(data);
  }, []);

  const renderTimePicker = (
    dateKey,
    timeKey,
    pkDate,
    pkTime,
    minDateKey = null,
    maxDateKey = null,
    hideDate = false,
  ) => (
    <span className="add-tsk-body-tm-prd-row-value">
      {!hideDate && (
        <>
          <ReactDatePicker
            selected={schedule[dateKey]}
            onChange={(date) => updateSchedule(dateKey, date)}
            onChangeRaw={(e) => {
              e.target.value = getMaskDate(e.target.value);
            }}
            onClickOutside={() => togglePicker(pkDate)}

            open={pickers[pkDate]}
            onSelect={() => togglePicker(pkDate)}
            className="add-task-date-picker"
            style={{ width: '75px' }}
            dateFormat={DEFAULT_DATE_FORMATE}
            minDate={minDateKey ? schedule[minDateKey] : null}
            maxDate={maxDateKey ? schedule[maxDateKey] : null}
            disabled={editMode}
          />
          <img
            width="10%"
            src="./images/calendar-icon.png"
            alt="calendar"
            onClick={() => !editMode && togglePicker(pkDate)}
            style={{
              marginRight: '20px',
              cursor: editMode ? 'default' : 'pointer',
            }}
          />
        </>
      )}
      <ReactDatePicker
        selected={schedule[timeKey]}
        onChange={(time) => {
          updateSchedule(timeKey, time);
          if (pickers[pkTime]) togglePicker(pkTime);
        }}
        onChangeRaw={(e) => {
          e.target.value = getMaskTime(e.target.value);
        }}
        onClickOutside={() => pickers[pkTime] && togglePicker(pkTime)}

        open={pickers[pkTime]}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        timeCaption="Time"
        dateFormat={
          defaultTimeFormat?.withoutSecond === 'HH:mm' ? 'HH:mm' : 'h:mm aa'
        }
        timeFormat={
          defaultTimeFormat?.withoutSecond === 'HH:mm' ? 'HH:mm' : undefined
        }
        placeholderText="00:00"
        className="add-task-date-picker"
        disabled={editMode}
      />
      <AccessTimeIcon
        fontSize="small"
        sx={{ color: 'orange', cursor: editMode ? 'default' : 'pointer' }}
        onClick={() => !editMode && togglePicker(pkTime)}
      />
    </span>
  );

  return (
    <div className="modalBackground">
      <div className="sch-addtsk-main-block">
        <div className="flex-sec item-center justify-between sch-addtsk-hdr-header">
          <span className="add-tsk-head">
            {eventData?.id ? 'Task' : 'New Task'}
          </span>
          <Button variant="circle" onClick={handleClose}>
            X
          </Button>
        </div>
        <div className="add-tsk-main-body" style={{ display: 'flex' }}>
          <span className="add-tsk-resorce-lbl">Type:</span>
          <div className="add-tsk-body-row" style={{ width: '40%' }}>
            <span className="add-tsk-resorce-lbl" style={{ width: '41%' }}>
              Block my calendar:
            </span>
            <span className="add-tsk-body-row-value">
              <input
                id="block_calander"
                name="block_calendar"
                type="radio"
                className="add-tsk-blk-tim-chk-bx"
                checked={isBlocked === '0'}
                onChange={(e) => setIsBlocked(e.target.value)}
                disabled={editMode}
                value={'0'}
              />
            </span>
          </div>
		  {/* <div className="add-tsk-body-row" style={{ width: '40%' }}>
            <span className="add-tsk-resorce-lbl" style={{ width: '40%' }}>
              Open my calendar:
            </span>
            <span className="add-tsk-body-row-value">
              <input
                id="open_calander"
                name="block_calendar"
                type="radio"
                className="add-tsk-blk-tim-chk-bx"
                checked={isBlocked === '2'}
                onChange={(e) => setIsBlocked(e.target.value)}
                disabled={editMode}
                value={'2'}
              />
            </span>
          </div>*/}
        </div>
        <div className="add-tsk-main-body">
          <div className="add-tsk-body-row">
            <span className="add-tsk-resorce-lbl">Resource:</span>
            <span className="add-tsk-body-row-value">
              <select
                id="providerid"
                className="chzn-select room-alot-selct width245-s"
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
                disabled={editMode}
              >
                <option value=""></option>
                {allData?.allResourceWithCode.length > 0 &&
                  allData?.allResourceWithCode.map((item, i) => (
                    <option
                      key={item?.id}
                      title={item?.resName}
                      value={item?.id}
                    >
                      {item?.resName}
                    </option>
                  ))}
              </select>
            </span>
          </div>
        </div>
        <div className="add-tsk-main-body">
          <div className="add-tsk-body-row">
            <span className="add-tsk-resorce-lbl">Location:</span>
            <span className="add-tsk-body-row-value">
              <select
                id="providerid"
                className="chzn-select room-alot-selct width245-s"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                disabled={editMode}
              >
                <option value="all">All</option>
                {allData?.allLocation.length > 0 &&
                  allData?.allLocation.map((item, i) => (
                    <option
                      key={item?.id}
                      title={item?.location_code}
                      value={item?.id}
                    >
                      {item?.location_code}
                    </option>
                  ))}
              </select>
            </span>
          </div>
        </div>
        <div className="add-tsk-main-body">
          <div className="add-tsk-body-row">
            <span className="add-tsk-resorce-lbl">Description:</span>
            <span className="add-tsk-body-row-value">
              <textarea
                id="taskDescription"
                className="add-tsk-res-txt-area"
                value={textDesc}
                onChange={(e) => setTextDesc(e.target.value)}
                disabled={editMode}
              ></textarea>
            </span>
          </div>
        </div>
        {isBlocked !== '2' && (
          <div className="add-tsk-main-body">
            <div className="add-tsk-body-row">
              <span className="add-tsk-resorce-lbl">Recurring:</span>
              <span className="add-tsk-body-row-value">
                <input
                  type="checkbox"
                  className="add-tsk-blk-tim-chk-bx"
                  checked={recurringCheck}
                  onChange={(e) => {
                    setRecurringCheck(e.target.checked);
                    if (e.target.checked === true) {
                      // setTaskDate({ ...taskDate, ndDate: taskDate?.stDate });
                    } else {
                      // setTaskDate({ ...taskDate, ndDate: null });
                    }
                  }}
                  disabled={eventData ? true : false}
                />
              </span>
            </div>
          </div>
        )}
        {recurringCheck ? (
          <div className="">
            <div className="add-tsk-main-body">
              <div className="add-tsk-body-row">
                <span className="add-tsk-resorce-lbl">Time period:</span>
                {renderTimePicker(
                  'startDateOcc',
                  'startTimeOcc',
                  'stDate',
                  'stTime',
                )}
                <span className="add-tsk-separator">-</span>
                {renderTimePicker(
                  'endTimeOcc',
                  'endTimeOcc',
                  'ndDate',
                  'ndTime',
                )}
              </div>
            </div>
            <div className="add-recrnc-blk">
              <RecurrencePopup
                appDate={false}
                handleRecurranceFormData={handleRecurranceFormData}
                taskDiv={true}
                recurData={allData?.taskInfo?.taskRecurData}
              />
            </div>
          </div>
        ) : (
          <div className="add-tsk-main-body">
            <div className="add-tsk-body-row">
              <span className="add-tsk-resorce-lbl">Time period:</span>
              {renderTimePicker(
                'startDate',
                'startTime',
                'stDate',
                'stTime',
                null,
                isBlocked === '2' ? null : 'endDate',
              )}
              <span className="add-tsk-separator">-</span>
              {renderTimePicker(
                'endDate',
                'endTime',
                'ndDate',
                'ndTime',
                'startDate',
                null,
                isBlocked === '2',
              )}
            </div>
          </div>
        )}
        <div
          className="flex-sec justify-between item-center"
          style={{ padding: '5px 10px' }}
        >
          <div>
            {fromCalFlag && eventData?.indv_task_id && (
              <Button
                variant="danger"
                onClick={() => handleDeleteTask(eventData?.indv_task_id)}
              >
                Delete
              </Button>
            )}
          </div>
          <div className="flex-sec justify-between item-center gap10">
            <Button variant="outline" onClick={handleClose}>
              Cancel
            </Button>
            {(editMode && eventData?.id && (
              <Button variant="secondary" onClick={() => setEditMode(false)}>
                Edit
              </Button>
            )) || (
              <Button variant="primary" onClick={handleSaveTask}>
                {eventData ? 'Update' : 'Save'}
              </Button>
            )}
          </div>
        </div>
      </div>
      {conFirmDelete?.status && (
        <ConfirmDialog
          title="Confirm"
          bodytext="Do you want to delete this task?"
          sucPrams={conFirmDelete?.id}
          closeDialog={() =>
            setConFirmDelete((prev) => ({ ...prev, status: false }))
          }
          successDialog={handleDeleteTempletConfirm}
        />
      )}
    </div>
  );
}

export default AddTaskPopup;
